import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { SettingsNavItem } from './settings-nav-item.atom'
import type { SettingsNavItem as SettingsNavItemType } from './settings-nav-item.interface'

export interface SettingsNavGroupProps {
  label?: string
  itemList: SettingsNavItemType[]
  activeItemId?: string
  onItemClick?: (item: SettingsNavItemType) => void
  className?: string
}

const SettingsNavGroupBase: React.FC<SettingsNavGroupProps> = ({
  label,
  itemList,
  activeItemId,
  onItemClick,
  className,
}): ReactNode => (
  <div className={cn('settings-nav-group flex flex-col gap-1', className)}>
    {label && (
      <h3 className="settings-nav-group-label mb-1 px-3 text-xs font-medium text-muted-foreground uppercase tracking-wider">
        {label}
      </h3>
    )}
    <nav className="settings-nav-group-items flex flex-col gap-0.5">
      {itemList.map((item) => (
        <SettingsNavItem
          key={item.id}
          label={item.label}
          icon={item.icon}
          isActive={activeItemId === item.id}
          onClick={() => onItemClick?.(item)}
        />
      ))}
    </nav>
  </div>
)

export const SettingsNavGroup = memo(SettingsNavGroupBase)

SettingsNavGroup.displayName = 'SettingsNavGroup'
